import React from 'react';
import styles from './ProductOffers.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Offer from './Offer';
import ListSortingHeading from './ListSortingHeading';

const ProductOffers = ({
  pricesHeaderRef,
  offersList: shopsOffers,
  changeSortOrder,
  activeShopsSortOrder,
  availableSortOptions,
  isExpiredProduct,
  clickout,
  size,
}) => {
  //todo: provide all needed information in api response with a little to none of client side processing

  const firstMatchingOffer = (offers) =>
    offers.find((offer) => {
      /** Checks if there's a size defined and it's not in the offer, it'll remove it */
      if (size && !offer.size.includes(size)) {
        return false;
      }

      return true;
    });

  const shopWithMatchingOffers = (shop) => firstMatchingOffer(shop.offers);
  //Currently api response contains array of shops providing this product
  //Filters out shop offers which don't contain requested size
  const matchingOffersList = shopsOffers.filter(shopWithMatchingOffers);
  const expiredOffer = isExpiredProduct ? matchingOffersList.find(({ expiredProduct }) => !!expiredProduct) : null;
  const offersList = isExpiredProduct
    ? matchingOffersList.filter(({ expiredProduct }) => !expiredProduct)
    : matchingOffersList;

  return (
    <div className="container">
      <div className="col-12-xs" ref={pricesHeaderRef}>
        <h2 className={styles.heading}>
          <FormattedMessage id="product.offers" defaultMessage="Offers" />
        </h2>
        <ListSortingHeading
          activeShopsSortOrder={activeShopsSortOrder}
          availableSortOptions={availableSortOptions}
          changeSortOrder={changeSortOrder}
        />
        {!offersList && (
          <section className={classNames(styles.offersList, styles.offersListPlaceholder)}>
            <div className={styles.offersSorting}></div>
            <div className={styles.offersListPlaceholderItem}></div>
            <div className={styles.offersListPlaceholderItem}></div>
          </section>
        )}
        <section className={classNames(styles.offersList)}>
          {!!expiredOffer && <Offer offer={expiredOffer} isExpiredProduct={isExpiredProduct} />}
          {offersList.map((offer) => (
            <Offer key={`offerid${offer?.id}`} offer={offer} clickout={clickout} />
          ))}
        </section>
      </div>
    </div>
  );
};

export default ProductOffers;
